<template>
  <div>
    <el-dialog class="dialog-main" :title="agreementDialogTitle" :visible.sync="dialogVisible" width="80%" center
               :before-close="dialogOnClose">
      <div class="dialog-content" v-html="agreement.content"></div>
      <span slot="footer" class="dialog-footer">
        <el-button style="width: calc(50% - 10px)" @click="onDialogCancel">取 消</el-button>
        <el-button style="width: calc(50% - 10px)" type="primary" @click="onDialogEnsure">确 定</el-button>
      </span>
    </el-dialog>

    <div class="home-page">
      <div class="back-btn setting-btn" @click="onSettingClick">
        <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#5c6460" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3.2"/><path d="M19.4 15a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1.04 1.56V21a2 2 0 1 1-4 0v-.09a1.7 1.7 0 0 0-1.12-1.56 1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.7 1.7 0 0 0 4.6 15a1.7 1.7 0 0 0-1.56-1.04H3a2 2 0 1 1 0-4h.09A1.7 1.7 0 0 0 4.65 8.9a1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.7 1.7 0 0 0 1.87.34h.08A1.7 1.7 0 0 0 10.13 3V3a2 2 0 1 1 4 0v.09c0 .68.4 1.3 1.04 1.56a1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.7 1.7 0 0 0-.34 1.87v.08c.24.63.86 1.04 1.52 1.04H21a2 2 0 1 1 0 4h-.09c-.68 0-1.3.4-1.51 1.04z"/></svg>
      </div>

      <div class="home-layout">
        <div class="home-left">
          <div class="home-heading">
            <div class="home-welcome">{{ homeWelcome }}</div>
            <div class="home-system">{{ systemName }}</div>
          </div>
          <div class="home-cards">
            <div v-for="card in cardList" :key="card.url" class="svc" @click="onCardClick(card.url, card.items)">
              <img class="ico" :src="card.image" alt="">
              <span class="name">{{ card.title }}</span>
            </div>
          </div>
        </div>

        <div class="qr-card" v-if="qrIsImage">
          <img class="qr-img" :src="qrImageSrc" draggable="false" alt="">
          <div class="qr-label">微信扫码预约</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import {mapMutations} from 'vuex'
import {getHomeSettingInfo, getVisitorConfigSetting} from "@/api/setting-api";
import {getDeviceAreaInfo} from "@/api/device-api";
import {getFileUrl} from "@/utils/fileUploadUtils";

export default {
  name: "HomePage",
  // get data from store
  components: {},

  computed: {
    privacyAgreement() {
      return this.$store.state.privacyAgreement
    },
    systemName() {
      return this.$store.state.homeInfo["SYSTEM_NAME"]
    },
    homeWelcome() {
      return this.$store.state.homeInfo["HOME_WELCOME"]
    },
    homeQrRegister() {
      return this.$store.state.homeInfo["HOME_QR_REGISTER"] ? this.$store.state.homeInfo["HOME_QR_REGISTER"] : ""
    },
    // 二维码配置=企业后台上传的二维码图片（objectKey，经 /api/file/download 读取）；
    // 未上传或历史遗留的链接配置一律不显示卡片
    qrIsImage() {
      return /\.(png|jpe?g|gif|webp|svg)(\?.*)?$/i.test((this.homeQrRegister || "").trim())
    },
    qrImageSrc() {
      return getFileUrl(this.homeQrRegister.trim())
    },
    cardList() {
      return this.$store.state.pageSetting
    },
  },

  data() {
    return {
      dialogVisible: false,
      targetPage: "",
      targetParams: [],

      agreement: {valid: false, content: ''},
      agreementDialogTitle: "隐私协议",

      timer: null,
    }
  },// end data

  beforeDestroy() {
    this.stopTimer()
  },
  mounted() {
    this.startTimer()
    console.log("HomePage mounted")

    let areaId = this.$store.state.areaId
    // 区域是可选配置（多数部署不配）：areaId 为空、区域不存在或查询失败均静默降级
    // （store 默认 areaInfo={verify:0}），不弹「服务器异常」误报。
    // 注意 connect 对未配区域设备下发字符串 "0"，不能用 truthy 判断，否则会把
    // getDeviceAreaInfo(0) 返回的 data:null 写进 store，导致后续提交链全部崩溃
    if (Number(areaId) > 0) {
      getDeviceAreaInfo(areaId).then(({data}) => {
        console.log("getDeviceAreaInfo", areaId, data)
        if (data.code === 200 && data.data && data.data.id) {
          this.setAreaInfo(data.data)
        } else {
          console.log("getDeviceAreaInfo false", data.msg)
        }
      }).catch(err => {
        console.error("getDeviceAreaInfo err", err)
      })
    }

  },

  methods: {
    ...mapMutations(["setPageSetting", "setAreaInfo", "setHomeInfo", "setVisitorConfigSetting"]),

    startTimer() {
      this.requestHomeData()
      this.$store.dispatch("requestAllAgreement")

      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(() => {
        this.requestHomeData()
        this.$store.dispatch("requestAllAgreement")
      }, 1000 * 60 * 60)
    },

    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },

    requestHomeData() {
      getHomeSettingInfo().then(({data}) => {
        console.log("getHomeSettingInfo", data)
        if (data.code === 200) {
          this.setHomePage(data.data)
        } else if (data.code === 401 || data.code === 402) {
          // 会话失效：http 拦截器已清会话并跳回连接向导，这里不再弹「服务器异常」吓用户
          console.log("getHomeSettingInfo session invalid", data.msg)
        } else {
          console.log("getHomeSettingInfo false", data.msg)
          this.showServerErrMsg(data.msg)
        }
      }).catch(err => {
        console.error("getHomeSettingInfo err", err)
        this.showNetErrMsg()
      })
      getVisitorConfigSetting().then(({data}) => {
        console.log("getVisitorConfigSetting", data)
        if (data.code === 200 && data.data.length >= 1) {
          // 解析 VISITOR_BOOK（预约/登记）字段显隐配置，身份证 idCardNo=1 表示全端隐藏
          let setting = {
            value: "NONE",
            depends: [{name: "ID", dependField: ""}, {name: "PASSPORT", dependField: ""}],
            idCardNo: 2,
            nationality: 1,
            passport: 1,
          }
          data.data.forEach(item => {
            if (item.type === "VISITOR_BOOK" && item.content) {
              try {
                const c = JSON.parse(item.content)
                if (c) {
                  setting = Object.assign(setting, c)
                }
              } catch (e) {
                console.error("parse VISITOR_BOOK content err", e)
              }
            }
          })
          this.setVisitorConfigSetting(setting)
        }
      }).catch(err => {
        console.error("getVisitorConfigSetting err", err)
        this.showNetErrMsg()
      })
    },

    preSetHomeData(key, value) {
      let homeInfo = this.$store.state.homeInfo
      homeInfo[key] = value
      this.setHomeInfo(Object.assign({}, homeInfo))
    },

    setHomePage(data) {
      let areaId = this.$store.state.areaId

      // 逐项容错：单个设置内容异常（如后台清空系统名称后保存成 {}）只跳过该项，
      // 不再中断其余设置——此前 settingContent[-1].ctn 对 {} 抛错，欢迎语/入场入口
      // 全部不处理，首页白屏只剩设置齿轮
      data.forEach(item => {
        try {
          switch (item.type) {
            case "SYSTEM_NAME":
              if (item.content) {
                this.preSetHomeData("SYSTEM_NAME", this.pickCtn(JSON.parse(item.content), areaId))
              }
              break
            case "COMPANY_LOGO":
              if (item.content) {
                this.preSetHomeData("COMPANY_LOGO", getFileUrl(this.pickCtn(JSON.parse(item.content), areaId)))
              }
              break
            case "HOME_WELCOME":
              if (item.content) {
                this.preSetHomeData("HOME_WELCOME", this.pickCtn(JSON.parse(item.content), areaId))
              }
              break
            case "HOME_BACKGROUND":
              if (item.content) {
                this.preSetHomeData("HOME_BACKGROUND", getFileUrl(this.pickCtn(JSON.parse(item.content), areaId)))
              }
              break
            case "HOME_QR_REGISTER":
              if (item.content) {
                this.preSetHomeData("HOME_QR_REGISTER", this.pickCtn(JSON.parse(item.content), areaId))
              }
              break
            case "HOME_ENTER_SETTING":
              this.setHomeEnter(item.content)
              break
            default:
              break
          }
        } catch (e) {
          console.error("setHomePage item err", item.type, e)
        }
      })
    },

    // 分区域设置取内容：区域开启开关且填了内容用区域的，否则回落全局(-1)；
    // 内容为空对象/缺键时返回空串（区域是可选配置）
    pickCtn(settingContent, areaId) {
      const globalCtn = (settingContent && settingContent["-1"] && settingContent["-1"].ctn) || ""
      const area = settingContent && settingContent[areaId]
      return (area && area.sw && area.ctn) ? area.ctn : globalCtn
    },

    setHomeEnter(data) {
      let keys = data.split("|");
      let cardList = []
      if (keys.includes(this.myPath.localRegister) || keys.includes(this.myPath.idCardRegister)) {
        let item = {
          title: "现场登记",
          url: this.myPath.localRegister,
          image: require("@/assets/local_register.png"),
          items: []
        }
        if (keys.includes(this.myPath.localRegister)) {
          item.items.push({
            title: "手工输入",
            url: this.myPath.localAddInfo,
            image: require("@/assets/icon_local_register.png")
          })
        }
        if (keys.includes(this.myPath.idCardRegister)) {
          item.items.push({
            title: "身份证",
            url: this.myPath.idCardRegister,
            image: require("@/assets/icon_ic_card.png")
          })
        }
        cardList.push(item)
      }
      if (keys.includes(this.myPath.qrcodeCome) || keys.includes(this.myPath.visitCodeCome) ||
          keys.includes(this.myPath.idCardCome) || keys.includes(this.myPath.phoneCome)) {
        let item = {
          title: "预约签到",
          url: this.myPath.enterSelect,
          image: require("@/assets/sign_enter.png"),
          items: []
        }
        if (keys.includes(this.myPath.qrcodeCome)) {
          item.items.push({
            title: "二维码签到",
            url: this.myPath.qrcodeCome,
            image: require("@/assets/icon_qr_code.png")
          })
        }
        if (keys.includes(this.myPath.visitCodeCome)) {
          item.items.push({
            title: "访客码签到",
            url: this.myPath.visitCodeCome,
            image: require("@/assets/icon_visitor_code.png")
          })
        }
        if (keys.includes(this.myPath.idCardCome)) {
          item.items.push({
            title: "身份证签到",
            url: this.myPath.idCardCome,
            image: require("@/assets/icon_ic_card.png")
          })
        }
        if (keys.includes(this.myPath.phoneCome)) {
          item.items.push({title: "手机号签到", url: this.myPath.phoneCome, image: require("@/assets/icon_phone.png")})
        }
        cardList.push(item)
      }
      if (keys.includes(this.myPath.qrcodeLeave) || keys.includes(this.myPath.visitCodeLeave) ||
          keys.includes(this.myPath.idCardLeave) || keys.includes(this.myPath.phoneLeave)) {
        let item = {
          title: "访客签离",
          url: this.myPath.leaveSelect,
          image: require("@/assets/sign_leave.png"),
          items: []
        }
        if (keys.includes(this.myPath.qrcodeLeave)) {
          item.items.push({
            title: "二维码签离",
            url: this.myPath.qrcodeLeave,
            image: require("@/assets/icon_qr_code.png")
          })
        }
        if (keys.includes(this.myPath.visitCodeLeave)) {
          item.items.push({
            title: "访客码签离",
            url: this.myPath.visitCodeLeave,
            image: require("@/assets/icon_visitor_code.png")
          })
        }
        if (keys.includes(this.myPath.idCardLeave)) {
          item.items.push({
            title: "身份证签离",
            url: this.myPath.idCardLeave,
            image: require("@/assets/icon_ic_card.png")
          })
        }
        if (keys.includes(this.myPath.phoneLeave)) {
          item.items.push({title: "手机号签离", url: this.myPath.phoneLeave, image: require("@/assets/icon_phone.png")})
        }
        cardList.push(item)
      }
      this.setPageSetting(cardList)
    },

    onCardClick(urlName, items) {
      let agreement = {}
      switch (urlName) {
        case this.myPath.registerSelect:
          agreement = this.$store.state.userAgreement
          this.agreementDialogTitle = "用户协议"
          break
        case this.myPath.visitCodeCome:
        case this.myPath.qrcodeCome:
          agreement = this.$store.state.signEnterAgreement
          this.agreementDialogTitle = "签到须知"
          break
        case this.myPath.visitCodeLeave:
        case this.myPath.qrcodeLeave:
          agreement = this.$store.state.signLeaveAgreement
          this.agreementDialogTitle = "签离须知"
          break
        default:
          break
      }

      console.log("onCardClick", urlName, agreement)
      if (agreement.focusRead) {
        this.agreement = agreement
        this.targetPage = urlName
        this.targetParams = items
        this.dialogVisible = true
      } else {
        this.$router.push({name: urlName, params: {items: items}})
      }
    },

    onDialogEnsure() {
      let urlName = this.targetPage
      // 协议确认后跳转同样要带 items（子页依赖它渲染子方式列表），与免协议分支对齐
      this.$router.push({name: urlName, params: {items: this.targetParams}})
      this.dialogVisible = false
    }
    ,
    onDialogCancel() {
      this.dialogVisible = false
      this.targetPage = ""
    }
    ,
    dialogOnClose() {
      this.targetPage = ""
      this.dialogVisible = false
    },

    onSettingClick() {
      // 密码错误后重开输入框（原实现弹窗关闭需重新点齿轮再输一遍）
      this.doSettingPrompt()
    },

    doSettingPrompt() {
      this.$prompt('请输入密码', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'password',
        inputPattern: /^[0-9]{6}$/,
        inputErrorMessage: '密码为6位数字'
      }).then(({value}) => {
        if (value === "123456") {
          this.$router.push({name: this.myPath.setting})
        } else {
          this.$message.error("密码错误")
          this.doSettingPrompt()
        }
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped lang="less">
.home-page {
  height: 100%;
  background: var(--bg);
  position: relative;

  .setting-btn {
    top: 96px;
    right: 96px;
  }
}

.home-layout {
  height: 100%;
  display: flex;
  padding: 40px 96px 110px;
  gap: 72px;
  box-sizing: border-box;
}

.home-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.home-heading {
  margin: 88px 0 96px;

  .home-welcome {
    font-size: 84px;
    font-weight: 700;
    letter-spacing: 0.02em;
    color: var(--ink);
    line-height: 1.4;
  }

  .home-system {
    font-size: 40px;
    color: var(--ink-3);
    margin-top: 28px;
    letter-spacing: 0.06em;
  }
}

.home-cards {
  display: flex;
  gap: 40px;

  .svc {
    flex: 1;
    height: 480px;
  }
}

.qr-card {
  width: 430px;
  align-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 64px 48px;
  gap: 40px;
  background: var(--panel);
  border: 1px solid var(--line);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
  flex: none;

  .qr-img {
    width: 320px;
    height: 320px;
    display: block;
  }

  .qr-label {
    font-size: 36px;
    font-weight: 600;
    color: var(--ink-2);
    letter-spacing: 0.04em;
  }
}
</style>
